var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8029_2912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_2912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_2912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8029_2912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8029_2912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24Z",
    fill: "url(#paint0_linear_8029_2912)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32745 14.8315L6.56095 16.8755C6.53152 16.9542 6.52535 17.0397 6.54318 17.1217C6.56101 17.2038 6.60209 17.279 6.6615 17.3384C6.72092 17.3977 6.79617 17.4387 6.87826 17.4565C6.96035 17.4742 7.04582 17.4679 7.12445 17.4384L9.16787 16.6719C9.40175 16.5843 9.61417 16.4477 9.79087 16.2712L15.7099 10.3521C15.7099 10.3521 15.5034 9.73318 14.8851 9.11427C14.2668 8.49594 13.6473 8.28944 13.6473 8.28944L7.7282 14.2085C7.55169 14.3852 7.41505 14.5976 7.32745 14.8315ZM14.4727 7.46402L15.2794 6.65727C15.4241 6.5126 15.6172 6.42044 15.819 6.45427C16.1031 6.50094 16.5377 6.6421 16.9472 7.05219C17.3573 7.46227 17.4984 7.89627 17.5451 8.18035C17.5789 8.38219 17.4868 8.57527 17.3421 8.71993L16.5348 9.52669C16.5348 9.52669 16.3289 8.90835 15.7099 8.29002C15.0916 7.67052 14.4727 7.46402 14.4727 7.46402Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8029_2912",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8029_2912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.4d5547d2ddf144b88af41a73cf38b96e.svg";
export { ForwardRef as ReactComponent };